import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import { useSelector } from 'react-redux';

const useStyles = makeStyles({
    card: {
        margin: 'auto',
        width: '80%',
    },
    title: {
        fontSize: 25,
    },
    pos: {
        marginBottom: 12,
    },
    fotoComponent: {
        width: '120px',
        borderRadius: '20px',
    },
});

export default function AlunoProfileV2() {
    const classes = useStyles();
    const usuario = useSelector(state => state.usuario);

    return (
        <Grid container direction='row' spacing={3} justifyContent='center' alignItems='center'>
            <Grid>
                <img
                    className={classes.fotoComponent}
                    src={usuario && usuario.alunoFoto ?
                        usuario.alunoFoto.foto : null}
                    alt=''
                />
            </Grid>
            <Grid>
                <p style={{ fontSize: '20px', fontWeight: 'bold' }}>
                    {usuario.arAlunoSelecionado &&
                        usuario.arAlunoSelecionado.nome ?
                        usuario.arAlunoSelecionado.nome :
                        ''}
                </p>
            </Grid>
        </Grid>
    );
}